const topics = [
  {
    title: "Factors",
    slug: "factors",
    standardNumber: "NC.4.OA.4",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Prime Numbers",
    slug: "primenumbers",
    standardNumber: "NC.4.OA.4",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Place Value",
    slug: "placevalue",
    standardNumber: "NC.4.NBT.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Expanded Form",
    slug: "expandedform",
    standardNumber: "NC.4.NBT.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Greater Than",
    slug: "greaterthan",
    standardNumber: "NC.4.NBT.7",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Equivalent Fractions",
    slug: "equivalentfractions",
    standardNumber: "NC.4.NF.1",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Compare Fractions",
    slug: "comparefractions",
    standardNumber: "NC.4.NF.2",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Add & Subtract Fractions",
    slug: "addsubtractfractions",
    standardNumber: "NC.4.NF.3",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Mixed to Improper",
    slug: "mixedtoimproper",
    standardNumber: "NC.4.NF.3",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Multiply times Whole",
    slug: "multiplytimeswhole",
    standardNumber: "NC.4.NF.4",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Fractions to Decimals",
    slug: "fractionstodecimals",
    standardNumber: "NC.4.NF.6",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Compare Decimals",
    slug: "comparedecimals",
    standardNumber: "NC.4.NF.7",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Liters & Milliliters",
    slug: "litersmilliliters",
    standardNumber: "NC.4.MD.1",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Grams & Kilos",
    slug: "gramskilos",
    standardNumber: "NC.4.MD.1",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Meter Meter What's the Measure",
    slug: "metermeterwhatsthemeasure",
    standardNumber: "NC.4.MD.1",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Elapsed Time",
    slug: "elapsedtime",
    standardNumber: "NC.4.MD.8",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Bar Graph",
    slug: "bargraph",
    standardNumber: "NC.4.MD.4",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Angles",
    slug: "angles",
    standardNumber: "NC.4.MD.6",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Angle Parts",
    slug: "angleparts",
    standardNumber: "NC.4.MD.6",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Lines",
    slug: "lines",
    standardNumber: "NC.4.G.1",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Quadrilaterals",
    slug: "quadrilaterals",
    standardNumber: "NC.4.G.2",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Triangles",
    slug: "triangles",
    standardNumber: "NC.4.G.2",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Symmetry",
    slug: "symmetry",
    standardNumber: "NC.4.G.3",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  }
];
export default topics;